import React, { useEffect, useState } from "react";

// react-router-dom components
import { useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import DashboardNavbar from "UIComponents/Navbars/DashboardNavbar";
// Material Dashboard 2 React context
import { useMaterialUIController, setLayout } from "context";
import Footer from "UIComponents/Footer";

//assets
import pxToRem from "assets/theme/functions/pxToRem";
import { styled } from "@mui/material/styles";
import { Backdrop } from "@mui/material";

function DashboardLayout({ children }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, miniLeftSidenav } = controller;
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname]);
  const ScrollLayout = styled("div")(({ theme, breakpoints }) => {
    return {};
  });

  return (
    <>

      <MDBox
        sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
          p: 4,
          position: "relative",
          minHeight: "86vh",
          backgroundColor: "#fafafa",
          justifyContent: "center",
          zIndex: "999",
          [breakpoints.up("xl")]: {
            marginTop: "16px",
            borderRadius: "7%",
            marginLeft: miniSidenav ? pxToRem(90) : pxToRem(241),
            marginRight: miniLeftSidenav ? pxToRem(90) : pxToRem(241),
            transition: transitions.create(["margin-left", "margin-right"], {
              easing: transitions.easing.easeInOut,
              duration: transitions.duration.standard,
            }),
          },
          [breakpoints.down('xl')]:{
            paddingRight:pxToRem(20)
          }
        })}
      >
        <DashboardNavbar />
        <ScrollLayout
          sx={({ breakpoints }) => ({
            [breakpoints.up("xl")]: {
              height: "83vh",
              overflowY: "scroll",
              overflowX: "hidden",
              paddingRight: pxToRem(32),
            },
          })}
        >
          {children}
        </ScrollLayout>
        <Footer />
      </MDBox>

    </>
  );
}

// Typechecking props for the DashboardLayout
DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
